import styled from 'styled-components';

import colors from '../../../../styles/colors';
import Button from '../../../../components/Button';

const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 40px 20px;
  text-align: center;
`;

const SuccessIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: ${colors.base.beta};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  
  svg {
    width: 40px;
    height: 40px;
    color: ${colors.base.alpha};
  }
`;

const SuccessTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${colors.shades.gamma7};
  margin: 0 0 16px 0;
`;

const SuccessMessage = styled.p`
  font-size: 16px;
  color: ${colors.shades.gamma2};
  margin: 0;
  max-width: 400px;
  line-height: 1.5;
`;

const DetailsContainer = styled.div`
  display: flex;
  padding: 12px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 12px;
  background-color: ${colors.shades.gamma3};
  width: 100%;
  border-radius: 8px;
`;

const DetailsRow = styled.div`
  display: flex;
  width: 100%;
`;

const DetailsLabel = styled.div`
  margin-bottom: 4px;
  width: 80px;
  display: flex;
`;

const DetailsValue = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 4px;
  width: 100%;
  align-items: flex-start;
`;

const StyledButton = styled(Button)`
  margin-top: 30px;
  cursor: pointer;
  background-color: ${colors.base.danger};
  color: ${colors.base.alpha};
`;

export {
  SuccessContainer,
  SuccessIcon,
  SuccessTitle,
  SuccessMessage,
  DetailsContainer,
  DetailsLabel,
  DetailsValue,
  DetailsRow,
  StyledButton,
};
